export default function CrimeVictimPart({dataItem, classes}) {
    return <>
        {dataItem && dataItem.submitted ? <>
            <h4 className={classes.flex_betwen}>Crime Victim
                <div className={classes.status}>
                    {dataItem.approved == null && 'Submitted'}
                    {dataItem.approved == 1 && <>
                        {dataItem.exhausted ? 'Exhausted' : 'Approved'}
                    </>}
                    {dataItem.approved == 0 && <>
                        {dataItem.appealed ? 'Appealed' : 'Denied'}
                    </>}
                </div>
            </h4>
            <div className={classes.background_container}>
                Amount of Statement Submitted ($): {dataItem.amount_submitted ? dataItem.amount_submitted : '-'}
            </div>
        </> : ''}
    </>
}